import {createAction} from 'typesafe-actions';

import type * as Types from './types';

export const setCustomRunName = createAction(
  '@view/customRunNames/setCustomRunName',
  action => (ref: Types.Ref, id: string, name: string) =>
    action({ref, id, name})
);
